import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticSevenSeatsMetaConfigMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.log
   * */
  constructor({config}) {
    super()
    this._config = config
    this._seoConfig = this._config.get('seo')
  }

  _getAdsListSemanticConfigKey = ({make, model, bodyType, province, fuelType}) => {
    const hasMake = Boolean(make)
    const hasModel = Boolean(model)
    const hasBodyType = Boolean(bodyType)
    const hasProvince = Boolean(province)
    const hasFuelType = Boolean(fuelType)

    // These are the seven combinations of SEO Metadata typologies
    // for sevenSeats ads-list pages [/7_plazas/]
    const isDefault = !hasMake && !hasBodyType && !hasProvince && !hasFuelType
    const isMake = hasMake && !hasBodyType
    const isBodyType = !hasMake && hasBodyType && !hasProvince
    const isMakeBodyType = hasMake && hasBodyType && !hasModel
    const isProvince = !hasMake && !hasBodyType && hasProvince
    const isBodyTypeProvince = !hasMake && hasBodyType && hasProvince
    const isFuelType = !hasMake && !hasBodyType && !hasProvince && hasFuelType

    switch (true) {
      case isDefault:
        return 'default'
      case isMake:
        return 'make'
      case isBodyType:
        return 'bodyType'
      case isMakeBodyType:
        return 'make'
      case isProvince:
        return 'province'
      case isBodyTypeProvince:
        return 'bodyTypeProvince'
      case isFuelType:
        return 'fuelType'
      default:
        return 'default'
    }
  }

  map = ({adsListSemanticConfig, params: {make, model, bodyType, province, fuelType}}) => {
    const adsListSemanticConfigKey = this._getAdsListSemanticConfigKey({
      make,
      model,
      bodyType,
      province,
      fuelType
    })
    return adsListSemanticConfig[adsListSemanticConfigKey] || adsListSemanticConfig.default
  }
}
